<section>
    <div class="col-12 my-4">
      <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Task Guideline</button>
      </div>
  </section>
  <section  id="taskboard" class="app-taskboard">
    
    <div class="row" >
      <div class="col-xl-3 col-sm-6 col-12">
        <h6 class="mt-2 mb-0">
          <span class="d-flex align-items-center">
            <i class="ft-cast mr-2"></i>
            <span>Urgent</span>
          </span>
        </h6>
        <div class='dragdrop-container' [dragula]='"ITEMS"' [id]="urgent_priority">
          <div class="card mb-3" *ngFor="let item of taskData_urgent ; let urgentIndex=index" [attr.task-index]="item._id" [attr.task-priority]="item.priority" [attr.task-priorityname]="item.priority">
            <div class="card-body">
              <div class="d-flex justify-content-between mb-2">
                <span class="badge bg-light-info mr-2" placement="top" ngbTooltip="Channel">{{item?.channelId?.name}}</span>
                <span class="badge bg-light-secondary mr-2" placement="top" ngbTooltip="Technology">{{item?.technology?.displayname}}</span>
                <div class="edit-del-btn">
                  <i class="ft-edit mr-1 primary cursor-pointer" (click)="openUpdateModal(myModalContent,item)" ></i>
                  <i class="ft-settings mr-1 primary cursor-pointer" placement="top" ngbTooltip="cover letter" (click)="openLetter(myModalLetter,item)"></i>
                  <i class="ft-trash-2 my-1  danger cursor-pointer" (click)="deleteReport(item._id,'urgent_priority')"></i>
                </div>
              </div>
              <div>
                <h6>{{item?.leads?.title}}</h6>
              </div>
              <p [innerHTML]="item.notes"></p>
              <div class="d-flex my-2 flex-box">
                <span class="badge bg-light-primary mx-1 my-1" placement="top" ngbTooltip="Farming By" *ngFor="let item of item?.assign_to">{{item?.name}}</span>
                <span class="badge bg-light-secondary mx-1 my-1" placement="top" ngbTooltip="Created By">{{item?.leads?.created_by?.name}}</span>
                </div>
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex font-small-2">
                  <div class="mr-2" *ngIf="item.updated_at!= ''"><i class="ft-clock mr-1"></i>{{item.updated_at | date:'medium'}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-sm-6 col-12">
        <h6 class="mt-2 mb-0">
          <span class="d-flex align-items-center">
            <i class="ft-cast mr-2"></i>
            <span>High</span>
          </span>
        </h6>
        <div class='dragdrop-container' [dragula]='"ITEMS"' [id]="high_priority">
          <div class="card mb-3" *ngFor="let item of taskData_high ; let highIndex =index" [attr.task-index]="item._id" [attr.task-priority]="item.priority" [attr.task-priorityname]="item.priority">
            <div class="card-body">
              <div class="d-flex justify-content-between mb-2">
                <span class="badge bg-light-info mr-2" placement="top" ngbTooltip="Channel">{{item?.channelId?.name}}</span>
                <span class="badge bg-light-secondary mr-2" placement="top" ngbTooltip="Technology">{{item?.technology?.displayname}}</span>
                <div class="edit-del-btn">
                  <i class="ft-edit mr-1 primary cursor-pointer" (click)="openUpdateModal(myModalContent,item)" ></i>
                  <i class="ft-settings mr-1 primary cursor-pointer" placement="top" ngbTooltip="cover letter" (click)="openLetter(myModalLetter,item)"></i>
                  <i class="ft-trash-2 my-1  danger cursor-pointer" (click)="deleteReport(item._id,'high_priority')"></i>
                </div>
              </div>
              <div>
                <h6>{{item?.leads?.title}}</h6>

              </div>
              <p [innerHTML]="item.notes"></p>
              <div class="d-flex my-2 flex-box">
                <span class="badge bg-light-primary mx-1 my-1" placement="top" ngbTooltip="Farming By" *ngFor="let item of item?.assign_to">{{item?.name}}</span>
                <span class="badge bg-light-secondary mx-1 my-1" placement="top" ngbTooltip="Created By">{{item?.leads?.created_by?.name}}</span>
                </div>
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex font-small-2">
                  <div class="mr-2" *ngIf="item.updated_at!= ''"><i class="ft-clock mr-1"></i>{{item.updated_at | date:'medium'}}</div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-sm-6 col-12">
        <h6 class="mt-2 mb-0">
          <span class="d-flex align-items-center">
            <i class="ft-cast mr-2"></i>
            <span>Medium</span>
          </span>
        </h6>
        <div class='dragdrop-container' [dragula]='"ITEMS"' [id]="medium_priority">
          <div class="card mb-3" *ngFor="let item of taskData_medium ; let mediumIndex=index" [attr.task-index]="item._id" [attr.task-priority]="item.priority" [attr.task-priorityname]="item.priority">
            <div class="card-body">
              <div class="d-flex justify-content-between mb-2">
                <span class="badge bg-light-info mr-2" placement="top" ngbTooltip="Channel">{{item?.channelId?.name}}</span>
                <span class="badge bg-light-secondary mr-2" placement="top" ngbTooltip="Technology">{{item?.technology?.displayname}}</span>
                <div class="edit-del-btn">
                  <i class="ft-edit mr-1 primary cursor-pointer" (click)="openUpdateModal(myModalContent,item)" ></i>
                  <i class="ft-settings mr-1 primary cursor-pointer" placement="top" ngbTooltip="cover letter" (click)="openLetter(myModalLetter,item)"></i>
                  <i class="ft-trash-2 my-1  danger cursor-pointer" (click)="deleteReport(item._id,'medium_priority')"></i>
                </div>
              </div>
              <div>
                <h6>{{item?.leads?.title}}</h6>

              </div>
              <p [innerHTML]="item.notes"></p>
              <div class="d-flex my-2 flex-box">
                <span class="badge bg-light-primary mx-1 my-1" placement="top" ngbTooltip="Farming By" *ngFor="let item of item?.assign_to">{{item?.name}}</span>
                <span class="badge 
                -light-secondary mx-1 my-1" placement="top" ngbTooltip="Created By">{{item?.leads?.created_by?.name}}</span>
                </div>
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex font-small-2">
                  <div class="mr-2" *ngIf="item.updated_at!= ''"><i class="ft-clock mr-1"></i>{{item.updated_at | date:'medium'}}</div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-sm-6 col-12">
        <h6 class="mt-2 mb-0">
          <span class="d-flex align-items-center">
            <i class="ft-cast mr-2"></i>
            <span>Normal</span>
          </span>
        </h6>
        <div class='dragdrop-container' [dragula]='"ITEMS"' [id]="normal_priority">
          <div class="card mb-3" *ngFor="let item of taskData_normal; let normalIndex =index" [attr.task-index]="item._id" [attr.task-priority]="item.priority" [attr.task-priorityname]="item.priority">
            <div class="card-body">
              <div class="d-flex justify-content-between mb-2">
                <span class="badge bg-light-info mr-2" placement="top" ngbTooltip="Channel">{{item?.channelId?.name}}</span>
                <span class="badge bg-light-secondary mr-2" placement="top" ngbTooltip="Technology">{{item?.technology?.displayname}}</span>
                <div class="edit-del-btn">
                  <i class="ft-edit mr-1 primary cursor-pointer" (click)="openUpdateModal(myModalContent,item)" ></i>
                  <i class="ft-settings mr-1 primary cursor-pointer" placement="top" ngbTooltip="cover letter" (click)="openLetter(myModalLetter,item)"></i>
                  <i class="ft-trash-2 my-1  danger cursor-pointer" (click)="deleteReport(item._id,'normal_priority')"></i>
                </div>
              </div>
              <div>
                <h6>{{item?.leads?.title}}</h6>
              </div>
              <p [innerHTML]="item.notes"></p>
              <div class="d-flex my-2 flex-box">
                <span class="badge bg-light-primary mx-1 my-1" placement="top" ngbTooltip="Farming By" *ngFor="let item of item?.assign_to">{{item?.name}}</span>
                <span class="badge bg-light-secondary mx-1 my-1" placement="top" ngbTooltip="Created By">{{item?.leads?.created_by?.name}}</span>
                </div>
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex font-small-2">
                  <div class="mr-2" *ngIf="item.updated_at!= ''"><i class="ft-clock mr-1"></i>{{item.updated_at | date:'medium'}}</div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      
  
     
      
  
    </div>
  </section>
  

  
  <!------------- Popup For Next_Action --------------------------------------->
<div>
  <ng-template #myModalContent>
    <div class="modal-header">
      <h4 class="modal-title">Next Activity</h4>
      <button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label>Assign To</label>
        <ng-select
				  [items]="emp_list"
				  bindLabel="name"
				  bindValue="_id"
				  [closeOnSelect]="false"
				  placeholder="Select user"
				  [(ngModel)]="selected_emp"
          [multiple]="true"
				  [ngModelOptions]="{ standalone: true }"
				  (change)="getEmpId($event)"
				>
				</ng-select>
      </div>
      <div class="form-group">
        <label>Priority</label>
        <ng-select
				  [items]="priority_list"
				  bindLabel="name"
				  bindValue="name"
				  [closeOnSelect]="false"
				  placeholder="Select Priority"
				  [(ngModel)]="selected_priority"
				  [ngModelOptions]="{ standalone: true }"
				  (change)="getPriorityId($event)"
				>
				</ng-select>
      </div>
      <div class="form-group">
        <label>Next Action</label>
        <ng-select [items]="nextactionList" bindLabel="displayname" bindValue="_id" placeholder="Select next action"
          [(ngModel)]="lead.next_action" [ngModelOptions]="{standalone: true}" (change)="getChangeNextAction($event)">
        </ng-select>
      </div>
      <div class="form-group">
        <label>Next Action Date</label>
        <input class="form-control" type="date" [(ngModel)]="lead.next_action_date"
          [ngModel]="this.lead.next_action_date | date: 'yyyy-MM-dd'">
      </div>
      <div class="form-group">
        <label>Next Action Time</label>
        <input class="form-control" type="time" [(ngModel)]="lead.next_action_time"
          [ngModel]="this.lead.next_action_time">
      </div>
      <div class="form-group">
        <label>Notes</label>
        <textarea class="form-control" [(ngModel)]="lead.notes" name="notes" id="notes" cols="30" rows="2"></textarea>
      </div>
      <div class="form-group">
        <label>Last Active Date</label>
        <input class="form-control" type="date" [(ngModel)]="lead.last_activedate"
          [ngModel]="this.lead.last_activedate | date: 'yyyy-MM-dd'">
      </div>

      <div class="form-group">
        <label>Last Response</label>
        <!-- <input class="form-control" type="text" [(ngModel)]="lead.lastresponse"> -->
        <textarea class="form-control" [(ngModel)]="lead.lastresponse" name="lastresponse" id="lastresponse"></textarea>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary task" (click)="updateTask()">Task Assign</button>
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Close</button>
      <button type="button" class="btn btn-primary" (click)="updateLead()">Save changes</button>
    </div>
  </ng-template>
</div>
  
  <div class="d-flex justify-content-between align-items-center">
      <ngx-spinner></ngx-spinner>
    </div>

    <!------------- Cover Letter Popup ------------------------>
<div>
  <ng-template #myModalLetter>
    <div class="modal-header">
      <h4 class="modal-title">Cover Letter</h4>
      <button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <p [innerText]="cover_letter"></p>
      </div>
    </div>
   
  </ng-template>
</div>
<!-- ---- End ------------ -->